import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"
import DevisTableLayout, { DevisTableTh, DevisTableThTotal } from './DevisTableLayout';
import Photos from '../../../commonModules/interface/input-files';
import { Grid, Table, TableBody, TableRow, TableCell, Box, Button, IconButton } from '@material-ui/core';
import { amber, deepPurple } from '@material-ui/core/colors';
import { ArrowBackIosRounded, ArrowBackRounded } from '@material-ui/icons';

const formatNumber = (number) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(number)
} 
const formatNumber2 = (number) => {
    return new Intl.NumberFormat('fr-FR').format(number)
} 
const infos = {
    products: { 
        name:"products", 
        total:"prodTotal", 
        title: "Équipements",
    },
    accessories : { 
        name:"accessories", 
        total:"accTotal", 
        title: "Filerie, Supports, Protections",
    },
    transport : { 
        name:"transport", 
        total:"transTotal", 
        title: "Transports, Assurances",
    },
    mod: { 
        name:"mod", 
        total:"modTotal", 
        title: "Génie Civil et Main d'Oeuvre",
    },
    warranty: { 
        name:"warranty", 
        total:"warrTotal", 
        title: "Garanties, Autres",
    },
}
const lists = Object.keys(infos)
const translate = {
    "Homme": "M",
    "Femme": "Mme"
}

class PreviewDevis extends Component {
    state = { 
        totals: {
            products: { 
                HT: 0, 
                TVA: 0, 
                TTC: 0,
            },
            accessories : { 
                HT: 0, 
                TVA: 0, 
                TTC: 0,
            },
            transport : { 
                HT: 0, 
                TVA: 0, 
                TTC: 0,
            },
            mod: { 
                HT: 0, 
                TVA: 0, 
                TTC: 0,
            },
            warranty: { 
                HT: 0, 
                TVA: 0, 
                TTC: 0,
            },
            
        },
        TOTAL: { 
            HT: 0, 
            TVA: 0, 
            TTC: 0,
        },
        
     }
    componentDidMount() {
        this.calcTotal()
    }
    calcTotal = async () => {
        const { devis } = this.props;
        let totals = {}
        let TOTAL =  { HT: 0, TVA: 0, TTC: 0}

        await lists.map( list => {
            if(devis[list].length > 0){

                totals[list] = devis[list].reduce((sumField, item) => {
                    sumField.HT = (sumField.HT || 0) + parseFloat(item.priceTotal)
                    sumField.TVA = (sumField.TVA || 0) + Math.round(parseFloat(item.priceTotal) * (parseFloat(item.TVA)/ 100))
                    sumField.TTC = (sumField.TTC || 0) + Math.round(parseFloat(item.priceTotal) * (1 + parseFloat(item.TVA)/ 100))
                    return sumField
                },{})
            }
        })
                
        await Object.values(totals).forEach(item => {
            TOTAL.HT += parseFloat(item.HT || 0)
            TOTAL.TVA += parseFloat(item.TVA || 0)
            TOTAL.TTC += parseFloat(item.TTC || 0)
        })
        
        console.log({TOTAL});

        this.setState({totals, TOTAL})
    }
    
    render() {
        const { devis, client} = this.props;
        // console.log('====================================');
        // console.log("[STATE] Single Devis ", this.state);
        // console.log('====================================');
        // ${!isEmpty(client.Type) && translate[client.Type]} 
        let clientName = `
        ${(client.Nom).toUpperCase()}  
        ${(client.Prénom)[0].toUpperCase() + (client.Prénom).substring(1).toLowerCase()}
        `
        return (
            <Grid>
                <Box p={1}>
                    {this.props.handleClosePrev &&
                        <IconButton 
                            color="secondary" 
                            onClick={this.props.handleClosePrev}
                            size="small"
                        >
                            <ArrowBackRounded />
                        </IconButton>
                    }
                </Box>
                <h3 className="text-center">Devis pour {clientName}</h3>
                <hr/>
                <div id="section-to-print" >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>ARESS</Grid>
                        <Grid item xs={6}>
                            <Table className="table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Facturé à:</TableCell>
                                        <TableCell>{clientName}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Adresse: </TableCell>
                                        <TableCell>{client.Localisation && client.Localisation[0] }</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Téléphone: </TableCell>
                                        <TableCell>{client.Téléphone}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Email: </TableCell>
                                        <TableCell>{client.Email}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                    <hr/>
                    <div className="table-responsive">
                        <Table className="table table-striped table-bordered">
                            {lists.map(listName => {
                                if(devis[listName].length > 0){
                                    return (
                                        <Fragment>
                                            <DevisTableTh ttc >
                                                <TableRow><TableCell colSpan={7}></TableCell></TableRow>
                                                <TableRow ><TableCell colSpan={7} className="text-left" style={{backgroundColor: amber[50]}}> {infos[listName].title} </TableCell></TableRow>
                                            </DevisTableTh>
                                            <TableBody>
                                                {devis[listName].map(prod => (
                                                    <TableRow key={prod.product_id}>
                                                        <TableCell>{prod.name}</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{prod.quantity}</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{formatNumber(prod.price)}</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{formatNumber(prod.priceTotal)}</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{prod.TVA}%</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{formatNumber(Math.round(parseFloat(prod.priceTotal) * (parseFloat(prod.TVA)/ 100)))}</TableCell>
                                                        <TableCell style={{ textAlign: "right"}}>{formatNumber(Math.round(parseFloat(prod.priceTotal) * (1 + parseFloat(prod.TVA)/ 100)))}</TableCell>
                                                        
                                                    </TableRow>
                                                ))
                                                }
                                                <TableRow className="" >
                                                    <TableCell colSpan={3}  style={{ textAlign: "right"}}>Sous-Total</TableCell>
                                                    <TableCell  style={{ textAlign: "right"}}>{formatNumber(this.state.totals[listName].HT)}</TableCell>
                                                    <TableCell  style={{ textAlign: "right"}} colSpan={2}>{formatNumber(this.state.totals[listName].TVA)}</TableCell>
                                                    <TableCell  style={{ textAlign: "right"}}>{formatNumber(this.state.totals[listName].TTC)}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Fragment>
                                    )
                                }
                            })}
                            <DevisTableThTotal ttc >
                                <TableRow><TableCell colSpan={7}></TableCell></TableRow>
                                {/* <TableRow ><TableCell colSpan={7} className="bgm-amber p-5">TOTAL</TableCell></TableRow> */}
                            </DevisTableThTotal>
                            <TableBody>
                                <TableRow style={{backgroundColor: amber[100]}}>
                                    <TableCell style={{ textAlign: "right", fontSize: "20px", fontWeight: 800, color: deepPurple[600]}} colSpan={3}>TOTAL</TableCell>
                                    <TableCell style={{ textAlign: "right", fontSize: "20px", fontWeight: 800, color: deepPurple[600]}}>{formatNumber(this.state.TOTAL.HT)}</TableCell>
                                    <TableCell style={{ textAlign: "right", fontSize: "20px", fontWeight: 800, color: deepPurple[600]}} colSpan={2}>{formatNumber(this.state.TOTAL.TVA)}</TableCell>
                                    <TableCell style={{ textAlign: "right", fontSize: "20px", fontWeight: 800, color: deepPurple[600]}}>{formatNumber(this.state.TOTAL.TTC)}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </Grid>
        );
    }
}

export default PreviewDevis;